module.exports = __webpack_public_path__ + "img/Base1.332421ba.svg";